"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAssets$ = exports.PropertyAssets$outboundSchema = exports.PropertyAssets$inboundSchema = void 0;
exports.propertyAssetsToJSON = propertyAssetsToJSON;
exports.propertyAssetsFromJSON = propertyAssetsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const imagetypes_js_1 = require("./imagetypes.js");
/** @internal */
exports.PropertyAssets$inboundSchema = z.object({
    brochures: z.nullable(z.array(z.string())),
    epcs: z.nullable(z.array(z.string())),
    floorplans: z.nullable(z.array(z.string())),
    images: z.nullable(imagetypes_js_1.ImageTypes$inboundSchema),
    listing_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    listing_id: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "listing_date": "listingDate",
        "listing_id": "listingId",
    });
});
/** @internal */
exports.PropertyAssets$outboundSchema = z.object({
    brochures: z.nullable(z.array(z.string())),
    epcs: z.nullable(z.array(z.string())),
    floorplans: z.nullable(z.array(z.string())),
    images: z.nullable(imagetypes_js_1.ImageTypes$outboundSchema),
    listingDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    listingId: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        listingDate: "listing_date",
        listingId: "listing_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyAssets$;
(function (PropertyAssets$) {
    /** @deprecated use `PropertyAssets$inboundSchema` instead. */
    PropertyAssets$.inboundSchema = exports.PropertyAssets$inboundSchema;
    /** @deprecated use `PropertyAssets$outboundSchema` instead. */
    PropertyAssets$.outboundSchema = exports.PropertyAssets$outboundSchema;
})(PropertyAssets$ || (exports.PropertyAssets$ = PropertyAssets$ = {}));
function propertyAssetsToJSON(propertyAssets) {
    return JSON.stringify(exports.PropertyAssets$outboundSchema.parse(propertyAssets));
}
function propertyAssetsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyAssets$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyAssets' from JSON`);
}
//# sourceMappingURL=propertyassets.js.map